import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, signal } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  // Signals
  width = signal(0);

  constructor() {
    if (this.isBrowser) {
      this.update();

      window.addEventListener('resize', () => this.update(), { passive: true });
    }
  }

  private update() {
    this.width.set(window.innerWidth);
  }

  isMobile(): boolean {
    return this.width() < 768;
  }

  isTablet(): boolean {
    return this.width() >= 768 && this.width() < 1024;
  }

  isDesktop(): boolean {
    return this.width() >= 1024;
  }
}
